import React from "react";
import { Sparkle20Filled } from "@fluentui/react-icons";
import { useWebAgentContext } from "./WebAgentContext";
import { useWebChatStyles } from "../WebChat/WebChatStyles";

export const WebAgentToggleButton: React.FC = () => {
  const { isOpen, setIsOpen } = useWebAgentContext();
  const styles = useWebChatStyles();

  if (isOpen) return null;

  return (
    <button
      className={styles.toggleButton}
      onClick={() => setIsOpen(true)}
      aria-label="Open Dining Agent"
      data-testid="webagent-toggle"
    >
      <span className={styles.toggleButtonIcon} aria-hidden="true">
        <Sparkle20Filled />
      </span>
      <span className={styles.toggleButtonText}>Dining Agent</span>
    </button>
  );
};
